import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch } from 'react-redux';
import { getRouteParams } from '../routing/getRouteParams';
import { QUERY_PARAM } from '../flow-settings/QUERY_PARAM';
import imageUrls from '../images/imageUrls';
import { getHistory } from '../routing/history';
import { useLoginRedirect } from '../signup-completed-redirection/useLoginRedirect';
import { Data } from '../signup-data/DATA';
import { useSignupData } from '../signup-data/useSignupData';
import { clearError } from '../store/error/action-creators';
import { reloadFlow } from '../store/flow/action-creators';
import { useTracker } from '../tracking/useTracker';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';

const VerificationLinkExpiredView = () => {
  const dispatch = useDispatch();
  const Tracker = useTracker();
  const {
    redirectToLogin
  } = useLoginRedirect();
  const errorKey = ErrorKey.EmailVerificationNotFound;
  const {
    setData: setToken
  } = useSignupData(Data.Token);

  const redirectToSignupFirstStep = () => {
    Tracker.signupInteraction('retry-confirm-email-from-failed-verification');
    const {
      queryParams,
      flowKey
    } = getRouteParams();
    const queryParamsNoToken = Object.keys(queryParams).reduce((params, param) => {
      params[param] = queryParams[param];
      return params;
    }, {});
    const searchNoToken = Object.keys(queryParamsNoToken).filter(param => param !== QUERY_PARAM.TOKEN).map(param => `${param}=${queryParamsNoToken[param]}`).join('&');
    getHistory().replace(`/${flowKey}?${searchNoToken}`);
    setToken(null);
    dispatch(clearError());
    dispatch(reloadFlow());
  };

  const trackLoginClick = () => {
    Tracker.signupInteraction('click-login-from-failed-verification');
    redirectToLogin();
  };

  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: errorKey,
    handleButtonClick: redirectToSignupFirstStep,
    imageURL: imageUrls.clock,
    onSentenceWithLinkClick: trackLoginClick
  });
};

export default VerificationLinkExpiredView;